const NetworkBandwidth = (props) => {
    return (
<>
<h1 className="d-title">Network Bandwidth Prediction</h1>
                  <hr />
                  <h3>Background</h3>
                  <p className="mt-2">
                    Mobile Backhaul is one of solutions when tower provider
                    delivered end to end connection from base station to
                    customer Core Network via fiber optic as physical interfaces
                    and metro ethernet network as transport technology.
                  </p>
                  <p>Mobile Backhaul technology components include:</p>
                  <ul>
                    <li>
                      Access Network: Gives user (devices) access to
                      telecommunication service
                    </li>
                    <li>
                      Backhaul: Connects the Access network to Core Network
                    </li>
                    <li>
                      Core Network: Interconnect networks, exchange information
                      with another sub-network
                    </li>
                  </ul>
                  <img
                    src="img/networkBandwidth/mobile_backhaul.png "
                    alt="Mobile Backhaul"
                    style={{objectFit: 'contain', maxWidth: '80%'}}
                    className="rounded mx-auto d-block w-75;"
                  />
                  <p className="mt-2">
                    A forecasting model was planned to be inserted into the
                    system, therefore the forecasting model was developed in
                    order to:
                  </p>
                  <ul>
                    <li>Cope with with the increase of bandwidth capacity</li>
                    <li>
                      Analyze the client's data efficiently or the benefit of
                      the business, both for the service and clients.
                    </li>
                    <li>Develop further business intelligence tools</li>
                  </ul>
                  <h3>Methodology</h3>
                  <p className="mt-2">Steps in developing the models include:</p>
                  <ul>
                    <li>
                      Data Pre-processing: handling anomalies, data structure
                      transformationt
                    </li>
                    <li>
                      Model Training: hyperparameter tuning, selecting two best
                      parameter combinations
                    </li>
                    <li>
                      Perfomance Comparison: Compare the error and result
                      generated by the models
                    </li>
                    <li>
                      Model Implementation: Data visualizatoin through Dashboard
                    </li>
                  </ul>
                  <img
                    src="img/networkBandwidth/process_flow.jpg"
                    alt="Process Flow"
                    style={{objectFit: 'contain', maxWidth: '35%'}}
                    className="rounded mx-auto d-block w-75 mb-2;"
                  />
                  <p className="mt-4">
                    The machine learning and dashboard modelling, including the
                    data processing were performed using R programming.
                  </p>
                  <p className="mt-2">
                    The dataset are obtained from one of the client's daily
                    network capacity usage data. The train data was ranged from
                    2/1/2019 to 8/31/2020, where as the test data was ranged
                    9/1/2020 to 9/30/2020. The model was planned to constantly
                    train the new data to generate the forecast value of the
                    next 30 days.
                  </p>
                  <h3>Forecasting Result</h3>
                  <p className="mt-2">
                    FARIMA (4,0.2,1) model achieves the least error with RMSE,
                    MAE and MAPE of 11.762, 9.329 and 11.950 respectively. The
                    models’ error values do not show significant differences.
                  </p>
                  <img
                    src="img/networkBandwidth/error_measurements.png "
                    alt="Forecast Result"
                    style={{objectFit: 'contain', maxWidth: '45%'}}
                    className="rounded mx-auto d-block w-75"
                  />
                  <div class="row mt-4">
                    <div class="col">
                      <img
                        src="img/networkBandwidth/farima_result.png "
                        alt="FARIMA Result"
                    style={{objectFit: 'contain', maxWidth: '85%'}}
                    className="rounded mx-auto d-block w-75;"
                      />
                    </div>
                    <div class="col">
                      <img
                        src="img/networkBandwidth/mlp_result.png "
                        alt="ANN-MLP Result"
                    style={{objectFit: 'contain', maxWidth: '100%'}}
                    className="rounded mx-auto d-block w-75;"
                      />
                    </div>
                  </div>
                  <p className="mt-2">
                    ANN-MLP forecast result resembles more the variation of the
                    past data, where as FARIMA forecast values creates a single
                    straight line in other words, almost identical forecast
                    values.
                  </p>
                  <p>
                    Consequently, ANN-MLP with parameter of (4,0.2,1) was
                    selected as the best model. This model was used to generate
                    the forecast value of the next 30 days in the dashboard.
                  </p>
                  <h3>Model Implementation</h3>
                  <p>
                    The dashboards provides the insights of data which includes
                    the average, minimum and maximum capacity usage.
                  </p>
                  <img
                    src="img/networkBandwidth/dashboard_proto.png"
                    alt="Dashboard Prototype"
                    style={{objectFit: 'contain', maxWidth: '60%'}}
                    className="rounded mx-auto d-block w-75;"
                  />
                  <p className='mt-3'>
                    Additionaly the forecast value of the next 30 days as shown
                    in the image above. It also provides options for the user to
                    select the desired client's usage data and whether the
                    clients require to upgrade their usage data based on their
                    registered capacity.
                  </p>
                  <p>
                    See the published paper &nbsp;
                    <a href="https://ieeexplore.ieee.org/document/9502256"
                      >here</a
                    >
                  </p>
                  <a href="index.html#projects" style={{textDecoration: 'none'}}>
                  </a>
                        </>

    )

}

export default NetworkBandwidth;